import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { StyledFormGroup, Feedback } from './Common';

const IndividualForm = ({
    register,
    sectionErrors,
    detailsPath
}) => {
    return (
        <Row>
            <StyledFormGroup as={Col} md="6">
                <Form.Label>Occupation <span className="text-danger">*</span></Form.Label>
                <Form.Control
                    type="text"
                    placeholder="Enter occupation"
                    {...register(`${detailsPath}.occupation`)}
                    isInvalid={!!sectionErrors.occupation}
                />
                <Feedback error={sectionErrors.occupation} />
            </StyledFormGroup>

            <StyledFormGroup as={Col} md="6">
                <Form.Label>Organization Name <span className="text-danger">*</span></Form.Label>
                <Form.Control
                    type="text"
                    placeholder="Enter organization name"
                    {...register(`${detailsPath}.organizationName`)}
                    isInvalid={!!sectionErrors.organizationName}
                />
                <Feedback error={sectionErrors.organizationName} />
            </StyledFormGroup>
        </Row>
    );
};

export default IndividualForm;
